import { createComponentStore } from '../../utils/createComponentStore';

const keyAuto = () => 'calc' + (Math.floor(Math.random() * 90000000) + 10000).toString();

const calculationData = () => ({
  key: keyAuto(),
  perform: 'BASIC',
  operator: '',
  round: 2,
  datetimefuncUnit: 'MINUTES',
  datetimefuncOperator: 'ADD',
  datetimeFormat: 'dd MMMM yyyy HH:mm',
  keyRandom: Math.random(),
});

const initData = () => [calculationData()];

// Data is an array — return rawData directly instead of spreading over initData()
const onLoadData = (rawData) => (Array.isArray(rawData) ? rawData : initData());

const { getStore, defaultStore } = createComponentStore({
  type: 'calculator',
  endpoint: 'calculator',
  registryKey: 'calculator',
  initData,
  onLoadData,

  extraState: () => ({
    position: null,
    fieldFocus: null,
    placeholders: [],
    error: false,
  }),

  extraActions: (set, get) => ({
    // Backward-compatible alias for prefillComponentStores
    setCalculatorData: (component) => {
      get().setComponentData(component);
    },

    setCalculatorName: (name) => set({ name }),

    setPlaceholders: (placeholders) => set({ placeholders }),

    setFocus: (indexCalculation, fieldFocus) =>
      set({ position: indexCalculation, fieldFocus, placeholders: [] }),

    setCalculation: (value, indexCalculation, type) => {
      set((s) => {
        const data = s.data.map((item, i) => {
          if (i !== indexCalculation) return item;
          const updated = { ...item };
          switch (type) {
            case 'key':
              updated.key = value;
              break;
            case 'perform':
              updated.round = 2;
              if (value === 'FUNCTION') {
                updated.perform = value;
                updated.func = '';
                updated.operator = [];
              } else {
                updated.perform = value;
                updated.operator = '';
                delete updated.func;
              }
              break;
            case 'func':
              updated.func = value;
              break;
            case 'operator':
              if (updated.perform === 'FUNCTION') {
                updated.operator = [...updated.operator, value];
              } else {
                updated.operator = value;
              }
              break;
            case 'round':
              updated.round = parseInt(value);
              break;
            case 'datetimefunc':
              updated.datetimefunc = value;
              break;
            case 'datetimefuncUnit':
              updated.datetimefuncUnit = value;
              break;
            case 'datetimevalue1':
              updated.datetimevalue1 = value;
              break;
            case 'datetimevalue2':
              updated.datetimevalue2 = value;
              break;
            case 'datetimefuncOperator':
              updated.datetimefuncOperator = value;
              break;
            case 'datetimeFormat':
              updated.datetimeFormat = value;
              break;
            default:
              break;
          }
          return updated;
        });
        return { data };
      });
    },

    addCalculation: () => {
      set((s) => ({ data: [...s.data, calculationData()] }));
    },

    deleteCalculation: (index) => {
      set((s) => ({ data: s.data.filter((_, i) => i !== index) }));
    },

    deleteChip: (indexChip, indexCalculation) => {
      set((s) => {
        const data = s.data.map((item, i) => {
          if (i !== indexCalculation) return item;
          const newOperator = [...item.operator];
          newOperator.splice(indexChip, 1);
          return { ...item, operator: newOperator };
        });
        return { data };
      });
    },

    deleteChipByType: (indexChip, indexCalculation, type) => {
      set((s) => {
        const data = s.data.map((item, i) => {
          if (i !== indexCalculation) return item;
          const updated = { ...item };
          if (updated[type] && Array.isArray(updated[type])) {
            const arr = [...updated[type]];
            arr.splice(indexChip, 1);
            updated[type] = arr;
          } else {
            updated[type] = undefined;
          }
          return updated;
        });
        return { data };
      });
    },
  }),
});

export function getCalculatorStore(componentId) {
  return getStore(componentId);
}

export default defaultStore;
